module.exports = __webpack_public_path__ + "img/katarina5.96674066.jpg";